import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { CasoMejoraCU2 } from '../../api/mejoraCU2Api';
import { FctEstado, FctGlifoAtencion } from '../../fct/react';
import { ESTADO_LABEL, ESTADO_FAMILIA, PRIORIDAD_NIVEL } from './estados';

interface Props {
  casos: CasoMejoraCU2[];
  loading: boolean;
  onRowClick: (caso: CasoMejoraCU2) => void;
}

const CasosTable: React.FC<Props> = ({ casos, loading, onRowClick }) => {
  const columns: ColumnsType<CasoMejoraCU2> = [
    { title: 'Código', dataIndex: 'codigo', key: 'codigo', width: 120, className: 'fct-mono' },
    { title: 'Título', dataIndex: 'titulo', key: 'titulo', width: 220, ellipsis: true },
    { title: 'Descripción', dataIndex: 'descripcion', key: 'descripcion', ellipsis: true },
    { title: 'Entidad', key: 'entidad', width: 160, render: (_, r) => `${r.entidadTipo} #${r.entidadRefId}` },
    { title: 'Prioridad', dataIndex: 'prioridad', key: 'prioridad', width: 110,
      render: (p: string) => <span><FctGlifoAtencion nivel={PRIORIDAD_NIVEL[p] ?? 'normal'} /> {p}</span> },
    { title: 'Estado', dataIndex: 'estado', key: 'estado', width: 140,
      render: (e: CasoMejoraCU2['estado']) => <FctEstado personalizado={{ etiqueta: ESTADO_LABEL[e], ...ESTADO_FAMILIA[e] }} /> },
    // Fecha con segundos, como hasta ahora: solo cambia la fuente y la alineación (R-13).
    { title: 'Creado', dataIndex: 'creadoEn', key: 'creadoEn', width: 160, className: 'fct-num', align: 'right',
      render: (v: string) => new Date(v).toLocaleString('es-ES') },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={casos}
      loading={loading}
      pagination={{ pageSize: 20, showSizeChanger: true, showTotal: (t) => `Total: ${t} casos` }}
      onRow={(record) => ({ onClick: () => onRowClick(record), style: { cursor: 'pointer' } })}
    />
  );
};

export default CasosTable;
